import { CaseNoteLink } from "@/common/components/case-note-link/CaseNoteLink";
import { ReadOnlyLinkField } from "@/common/components/read-only-link-field/ReadOnlyLinkField";
import { useTranslation } from "@/translations";

interface Props {
  caseNoteId?: string | null;
  caseNoteLabel?: string | null;
  clientId?: string | null;
}

/**
 * Read-only "Aktenvermerk" field for the assignment dialogs. Renders nothing when the assignment
 * is not linked to a case note. With a {@link clientId} it shows a navigable {@link CaseNoteLink}
 * (details dialog); otherwise a disabled text field showing the note type (creation dialog).
 */
export function ReadOnlyCaseNoteField({ caseNoteId, caseNoteLabel, clientId }: Props) {
  const { t } = useTranslation();

  if (!caseNoteId) {
    return null;
  }
  const displayText = caseNoteLabel ?? t("assignments.creationDialog.caseNote");

  return (
    <ReadOnlyLinkField
      label={t("assignments.creationDialog.caseNote")}
      value={displayText}
      link={
        clientId ? (
          <CaseNoteLink clientId={clientId} caseNoteId={caseNoteId} label={displayText} variant="body2" />
        ) : undefined
      }
    />
  );
}
